<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" #treeSelector style="margin-left: 20px">
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
        This padding value depends on the mat-icon-button width. -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <!-- {{node.name}} -->

    <li class="mat-tree-node">
      <div style="margin-right: 30px">
        <div *ngIf="node.type === treeType.INPUT_TREE" style="display: inline-block; min-width: 150px">
          <p class="category" [attr.data-cy]="getPartKey(node)" tooltip="Open setup dialog..." (click)="openCategoryDialog(node)">
            <span>&#8226;</span>
            {{ node.name | formatKey }}
          </p>
        </div>

        <div *ngIf="node.type === treeType.VERSION_TREE || node.type === treeType.NO_VERSION_TREE" style="display: inline-block; min-width: 150px">
          <usimweb-status-bar *ngIf="progressVersions" class="progress" [mode]="'indeterminate'"></usimweb-status-bar>

          <div style="display: inline-block">
            <p class="category" *ngIf="currentVersion(node) && node.type === treeType.VERSION_TREE" tooltip="Open simulation..." (click)="showSim(node)">
              <span>&#8226;</span>
              <span class="currentVersion">{{ node.name | formatKey }}</span>
            </p>
            <p class="category" *ngIf="!currentVersion(node) && node.type === treeType.VERSION_TREE" tooltip="Open simulation..." (click)="showSim(node)">
              <span>&#8226;</span>
              {{ node.name | formatKey | slice: 0 : 15 }}{{ (node.name | formatKey).length > 15 ? '...' : '' }}
            </p>
            <p class="category" *ngIf="!currentVersion(node) && node.type === treeType.NO_VERSION_TREE" tooltip="No simulations...">
              <span>&#8226;</span>
              {{ node.name | formatKey }}
            </p>
          </div>

          <div *ngIf="node.type === treeType.VERSION_TREE" style="display: inline-block; margin-left: 10px">
            <mat-icon tooltip="Edit simulation name..." class="deleteObjBtn" (click)="renameSim(node)" style="color: #0059b3"> edit </mat-icon>

            <mat-icon tooltip="Delete version..." class="deleteObjBtn space" (click)="deleteVersion(node)" style="color: red"> delete </mat-icon>
          </div>
        </div>

        <!-- add here delete btn -->
        <div style="display: inline-block">
          <mat-icon tooltip="Delete object..." [attr.data-cy]="getDeleteKey(node)" class="deleteObjBtn" *ngIf="isDeleteObj(node)" (click)="deleteActor(node)" style="color: red">
            delete
          </mat-icon>
        </div>

        <div style="display: inline-block; margin-left: 10px">
          <mat-icon tooltip="Add default object..." [attr.data-cy]="getNewPartKey(node)" class="addDefaultBtn" *ngIf="isMultiObj(node)" (click)="addDefaultActor(node)">
            add
          </mat-icon>
        </div>

        <!-- <div style="display: inline-block" class="checkBox" *ngIf="isDeleteObj(node)">
            <mat-checkbox
              [checked]="node.isActive"
              (change)="toggleSetup(node, $event.checked)"
              tooltip="Enable/Disable simulation setup..."></mat-checkbox>
          </div> -->
      </div>
    </li>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li style="margin-left: -10px">
      <div class="mat-tree-node">
        <button [attr.data-cy]="getPartToggleKey(node)" (click)="collapse(node)" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>

        {{ node.name | formatKey }}

        <div style="display: inline-block">
          <mat-icon [attr.data-cy]="getNewPartKey(node)" tooltip="Add new object..." class="addObjBtn" *ngIf="isMultiObj(node)" (click)="addActor(node)"> add </mat-icon>
        </div>
      </div>
      <!-- There is inline padding applied to this div using styles.
               <ul [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
              This padding value depends on the mat-icon-button width.  -->
      <ul [class.tree-invisible]="!node.collapse && !treeControl.isExpanded(node)" role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>

    <hr *ngIf="showSeparator(node)" class="solid" />
  </mat-nested-tree-node>
</mat-tree>
